module.exports = __webpack_public_path__ + "static/media/chef.fcb23ca2.jpg";